import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list = _resolveComponent("list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_provinceList = _resolveComponent("provinceList")!
  const _component_cityList = _resolveComponent("cityList")!
  const _component_countiesList = _resolveComponent("countiesList")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "1",
                tab: "国家信息"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_list)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "2",
                tab: "省/州信息"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_provinceList)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "3",
                tab: "城市信息"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_cityList)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "4",
                tab: "县区信息"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_countiesList)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}